var SchemeCategoryMapper = function (response) {
    // Default static tabs
    // const defaultTabs: Array<IMFSchemeCategoryEntity> = [
    //   { title: `All`, eventKey: `all` },
    //   { title: `Featured`, eventKey: `featured` },
    //   { title: `Newly Added`, eventKey: `newly-added` },
    // ];
    if (response && response.data.length > 0) {
        var tabList = response.data.map(function (item) {
            return {
                title: item === null || item === void 0 ? void 0 : item.catName,
                eventKey: item === null || item === void 0 ? void 0 : item.catName.toLowerCase(),
                eventCode: item === null || item === void 0 ? void 0 : item.catCode,
            };
        });
        return { tabList: tabList };
    }
    return {};
};
export default SchemeCategoryMapper;
